import {all, call, fork, put, take} from "redux-saga/effects";
import {ClientBookmark} from "../../domain/model/client_bookmark";
import {Customer} from "../../domain/model/customer";
import {IClientBookmarkRepository} from "../../domain/repository/client_bookmark_repository";
import {ICustomerRepository, TSearchCustomerRequest,} from "../../domain/repository/customer_repository";
import {IJobCareerRepository, TJobCareerWithCustomerID,} from "../../domain/repository/job_career_repository";
import {createApiClient, IApiClient} from "../../infra/api/client";
import {createClientBookmarkAPI} from "../../infra/api/service/client_bookmark_api";
import {createCustomerAPI} from "../../infra/api/service/customer_api";
import {createJobCareerAPI} from "../../infra/api/service/job_career_api";
import {
    ClientScoutCustomerListActionType,
    createClientScoutCustomerListActionCreator,
    IClientScoutCustomerListActionCreator,
    IRequestSearchCustomerListAction,
} from "../action/client_scout_customers_action";
import {SearchCustomerListByClientResponse} from "../response/scout_response";
import {handleErrorForHandler} from "./handleErrorForHandler";

const apiClient: IApiClient = createApiClient();
const customerRepository: ICustomerRepository = createCustomerAPI(apiClient);
const jobcareerRepository: IJobCareerRepository = createJobCareerAPI(apiClient);
const clientBookmarkRepository: IClientBookmarkRepository =
    createClientBookmarkAPI(apiClient);
const actionCreator: IClientScoutCustomerListActionCreator =
    createClientScoutCustomerListActionCreator();

function* handleSearchCustomerListInClientScoutCustomerList() {
    while (true) {
        try {
            const action: IRequestSearchCustomerListAction = yield take(
                ClientScoutCustomerListActionType.REQUEST_SEARCH_CUSTOMER_LIST
            );

            let customerList: Customer[];
            let customerCount: number;
            let clientBookmarks: ClientBookmark[];
            const searchCustomerRequest: TSearchCustomerRequest = {
                page: action.item.pager.page,
                offset: action.item.pager.offset,
                query: action.item.query,
                singleSkillTagIDs: action.item.singleSkillTagIDs,
                multiSkillTagIDs: action.item.multiSkillTagIDs,
                occupationSkillTagCategory: action.item.occupationSkillTagCategory,
                occupationSkillTagId: action.item.occupationSkillTagId,
                gender: action.item.gender,
                age: action.item.age,
                workIntention: action.item.workIntention,
                fullTimePossibility: action.item.fullTimePossibility,
            };


            [customerList, customerCount, clientBookmarks] = yield all([
                call(searchCustomerList, searchCustomerRequest),
                call(getCountBySearch, searchCustomerRequest),
                call(getAllClientBookmark),
            ]);

            const customerIdList: string[] = yield call(
                createCustomerIdList,
                customerList
            );
            const jobCareersWithCustomerID: TJobCareerWithCustomerID[] = yield call(
                getJobcareerAllByCustomerIDs,
                customerIdList
            );

            const res: SearchCustomerListByClientResponse =
                new SearchCustomerListByClientResponse();
            res.customers = customerList;
            res.customerCount = customerCount;
            res.jobCareersWithCustomerID = jobCareersWithCustomerID;
            res.clientBookmarks = clientBookmarks;

            yield put(actionCreator.callbackSearchCustomerListAction(true, res));
        } catch (error) {
            yield fork(handleErrorForHandler, error);
            yield put(actionCreator.callbackSearchCustomerListAction(false));
        }
    }
}

const createCustomerIdList = (customerList: Customer[]): string[] => {
    return customerList.map((item: Customer) => {
        return item.id;
    });
};

const searchCustomerList = (r: TSearchCustomerRequest): Promise<Customer[]> => {
    return customerRepository.getAllBySearch(
        r.query,
        r.singleSkillTagIDs,
        r.multiSkillTagIDs,
        r.occupationSkillTagCategory,
        r.occupationSkillTagId,
        r.gender,
        r.age,
        r.workIntention,
        r.fullTimePossibility,
        r.page,
        r.offset
    );
};

const getJobcareerAllByCustomerIDs = (
    ids: string[]
): Promise<TJobCareerWithCustomerID[]> => {
    return jobcareerRepository.getAllByCustomerIDsForScout(ids);
};

const getCountBySearch = (
    r: TSearchCustomerRequest
): Promise<number | Long> => {
    return customerRepository.getCountBySearch(
        r.query,
        r.singleSkillTagIDs,
        r.multiSkillTagIDs,
        r.occupationSkillTagCategory,
        r.occupationSkillTagId,
        r.gender,
        r.age,
        r.workIntention,
        r.fullTimePossibility
    );
};

const getAllClientBookmark = (): Promise<ClientBookmark[]> => {
    return clientBookmarkRepository.getAllByClient();
};

export {handleSearchCustomerListInClientScoutCustomerList};



// WEBPACK FOOTER //
// ./src/presentation/handler/client_scout_customers_handler.ts